export const DashboardIcon = () => (
  <svg width="17" height="19" viewBox="0 0 17 19" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 18.7598V6.75977L8.5 0.759766L16.5 6.75977V18.7598H10.5V11.7598H6.5V18.7598H0.5Z" fill="#5C5C5C" />
  </svg>
);
